import { z } from 'zod'

const LegalAgreementSchema = z.object({
  title: z.string(),
  document_type: z.string(),
  version_id: z.string(),
  required_interaction: z.string(),
  required: z.boolean(),
})

const LegalAgreementIdentitySchema = LegalAgreementSchema.pick({
  version_id: true,
  document_type: true,
})

const LegalAgreementCaptureSchema = z.object({
  signature: z.string().optional(),
})

const LegalAgreementSubmissionSchema = LegalAgreementIdentitySchema.merge(LegalAgreementCaptureSchema)

export const LegalAgreementsResponseSchema = z.object({
  documents: z.array(LegalAgreementSchema),
})

export type LegalAgreement = z.infer<typeof LegalAgreementSchema>
export type LegalAgreementsData = z.infer<typeof LegalAgreementsResponseSchema>
export type LegalAgreementIdentity = z.infer<typeof LegalAgreementIdentitySchema>
export type LegalAgreementCapture = z.infer<typeof LegalAgreementCaptureSchema>
export type LegalAgreementSubmission = z.infer<typeof LegalAgreementSubmissionSchema>
export type AgreementCompletedArgs = [LegalAgreementIdentity, LegalAgreementCapture]

export function deserializeLegalAgreementsData(data: unknown): LegalAgreementsData {
  return LegalAgreementsResponseSchema.parse(data)
}

export function toLegalAgreementSubmission([agreement, capture]: AgreementCompletedArgs): LegalAgreementSubmission {
  return capture.signature ? { ...agreement, signature: capture.signature } : agreement
}
